import React from 'react';

const Title = (props) => {
    return (
        <div className="row">
            <div className="col-xs-12">
                <h1>{props.titulo}</h1>
            </div>
        </div>
    );
}

export default Title;